import React from 'react';
import PropTypes from 'prop-types';

import styles from './document-modal.module.css';

const QuestionNumber = ( { number } ) => {
	return (
		<div className={ styles.questionNumber }>
			{ number }
		</div>
	);
};

QuestionNumber.propTypes = { number: PropTypes.string };

export default QuestionNumber;
